export default {
  auth: { method: 'post', url: './auth' },
  option: './options',
  // login: '/hosp/user/who',
  // permissions: '/hosp/v2/role/user/permissions',
  // logout: { method: 'post', url: '/user/logout' }
}
